
import { defineComponent, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { IToken } from '@/types/interfaces';
/* eslint-disable import/no-cycle */
import AuthService from '@/modules/auth/services/AuthService';
import MonitoringService from '@/services/MonitoringService';

export default defineComponent({
  setup() {
    const route = useRoute();
    const message = ref('\u00A0');

    onMounted(() => {
      const tokenParam = route.query.token?.toString();
      AuthService.confirmEmail({ token: tokenParam } as IToken).then((response) => {
        if (response.success) {
          message.value = 'registration.confirm.email.success';
        } else {
          message.value = 'registration.confirm.email.failure';
        }
      });
      MonitoringService.sendPageMountedSpeed();
    });

    return {
      message,
    };
  },
});
